import internationalPaymentConfigTypes from './types';

// add bank account
export const addBankAccount = (data, cb) => ({
  type: internationalPaymentConfigTypes.ADD_BANK_ACCOUNT_REQUEST,
  payload: { data, cb },
});
export const addBankAccountSuccess = () => ({
  type: internationalPaymentConfigTypes.ADD_BANK_ACCOUNT_SUCCESS
});
export const addBankAccountFailure = (error) => ({
  type: internationalPaymentConfigTypes.ADD_BANK_ACCOUNT_FAILURE,
  error,
});

// get bank account
export const getBankAccount = () => ({
  type: internationalPaymentConfigTypes.GET_BANK_ACCOUNT_REQUEST
});
export const getBankAccountSuccess = (payload) => ({
  type: internationalPaymentConfigTypes.GET_BANK_ACCOUNT_SUCCESS,
  payload
});
export const getBankAccountFailure = (error) => ({
  type: internationalPaymentConfigTypes.GET_BANK_ACCOUNT_FAILURE,
  error,
});